<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="状态" class="fn-left">
            <Select key="5" :selected.sync="listQuery.isDelete" :data="stockStatus" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="类型" class="fn-left">
            <Select key="5" :selected.sync="listQuery.exerciseType" :data="stockTypes" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetExerciseList">查询</el-button>
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="fnAddExercise()">添加</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="ID" prop="exercise_id" align="center" />
        <el-table-column label="名称" prop="exercise_title" align="center" />
        <el-table-column label="类型" prop="exercise_type_name" align="center" />
        <el-table-column label="奖励类型" prop="award_type_name" align="center" />
        <el-table-column label="状态" align="center">
          <template slot-scope="{row}">
            <p>{{ row.is_delete == 1 ? "关闭" : "开启" }}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="fnGetExerciseDetail(row.exercise_id)">查看</el-button>
            <el-button v-if="row.is_delete != 1" type="text" @click="fnDeleteExercise(row.exercise_id)">关闭</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="total" :page-size="listQuery.limit" @current-change="fnGetExerciseList" />
    </div>
    <el-dialog title="行权计划" :visible.sync="bShowExericseDetail" width="70%">
      <el-table :key="tableExerciseDetailKey" :data="exerciseLists" border stripe>
        <el-table-column label="行权日期" prop="exercise_id" align="center">
          <template slot-scope="{row}">
            <p>{{ row.days }}天</p>
          </template>
        </el-table-column>
        <el-table-column label="行权股份" prop="exercise_title" align="center">
          <template slot-scope="{row}">
            <p>{{ row.percent }}%</p>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="添加行权" :visible.sync="bCreateExercise" width="70%">
      <el-form ref="createExerciseForm" :model="createExerciseForm" :rules="createExerciseRule">
        <el-form-item label="名称" prop="exercise_title">
          <el-input v-model="createExerciseForm.exercise_title" placeholder="请输入" style="width: 200px;" />
        </el-form-item>
        <el-form-item label="股金类型" prop="exercise_type">
          <Select key="7" :selected.sync="createExerciseForm.exercise_type" :data="stockTypes" clearable placeholder="请选择" />
        </el-form-item>
        <el-form-item label="奖励类型" prop="award_type">
          <Select key="8" :selected.sync="createExerciseForm.award_type" :data="awardTypes" clearable placeholder="请选择" />
        </el-form-item>
        <el-form-item label="计划" prop="exercise_schedule">
          <el-button type="primary" size="mini" @click="fnAddSchedule">添加</el-button>
          <el-table :key="dialogCreateExerciseKey" :data="createExerciseForm.exercise_schedule" border stripe>
            <el-table-column label="行权日期" prop="exercise_id" align="center">
              <template slot-scope="scope">
                <el-input-number v-if="createExerciseForm.exercise_schedule[scope.$index].isEdit" v-model="createExerciseForm.exercise_schedule[scope.$index].days" :min="0" />
                <p v-if="!createExerciseForm.exercise_schedule[scope.$index].isEdit">{{ createExerciseForm.exercise_schedule[scope.$index].days }}天</p>
              </template>
            </el-table-column>
            <el-table-column label="行权股份" align="center">
              <template slot-scope="scope">
                <el-input-number v-if="createExerciseForm.exercise_schedule[scope.$index].isEdit" v-model="createExerciseForm.exercise_schedule[scope.$index].percent" :min="1" :max="100" />
                <p v-if="!createExerciseForm.exercise_schedule[scope.$index].isEdit">{{ createExerciseForm.exercise_schedule[scope.$index].percent }}%</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button v-if="createExerciseForm.exercise_schedule[scope.$index].isEdit" type="primary" size="mini" @click="fnUpdateCreateExerciseList(scope.$index)">确定</el-button>
                <el-button v-if="!createExerciseForm.exercise_schedule[scope.$index].isEdit" type="primary" size="mini" @click="fnDeleteCreateExerciseList(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fnSubmitCreateExercise">确定</el-button>
      </div>
    </el-dialog>
  </div>

</template>
<script>

import Select from '@/components/Select'
import commondata from '@/utils/commondata'
import { validateRequire } from '@/utils/validate'

import Tool from '@/assets/js/tool.js'

const defaultCreateExerciseForm = {
  exercise_title: '',
  exercise_type: '',
  exercise_schedule: [],
  award_type: ''
}

export default {
  name: 'StockExerciseList',
  components: {
    Select
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      tableExerciseDetailKey: 0,
      total: 0,
      currentFood: '',
      bShowExericseDetail: false,
      bCreateExercise: false,
      exerciseLists: [],
      createExerciseForm: Object.assign({}, defaultCreateExerciseForm),
      listQuery: {
        p: 1,
        limit: 20,
        exerciseType: '',
        food_name: ''
      },
      createExerciseRule: {
        exercise_title: [{ validator: validateRequire, trigger: 'manual', message: '名称' }],
        exercise_type: [{ validator: validateRequire, trigger: 'manual', message: '股金类型' }],
        exercise_schedule: [{ validator: validateRequire, trigger: 'manual', message: '计划' }],
        award_type: [{ validator: validateRequire, trigger: 'manual', message: '奖励类型' }]
      },
      dialogCreateExerciseKey: 0,
      stockTypes: commondata.STOCK_TYPE,
      stockStatus: commondata.OPEN_STATUS,
      awardTypes: []
    }
  },
  created() {
    this.fnGetExerciseList()
    this.fnGetAwardLists()
  },
  methods: {
    fnAddSchedule: function() {
      this.createExerciseForm.exercise_schedule.push({ isEdit: true })
    },
    fnGetAwardLists: function() {
      this.$http.getAwardType().then(res => {
        (res.data || []).forEach((ele) => {
          ele.name = ele.display
        })
        this.awardTypes = res.data
      })
    },
    fnGetExerciseDetail(exerciseId) {
      this.bCreateExercise = false
      this.$http.getExerciseScheduleInfo({ exerciseId }).then(res => {
        this.exerciseLists = res.data.exercise_schedule
        this.bShowExericseDetail = true
      })
    },
    verifySchedule() {
      var total = 0
      this.createExerciseForm.exercise_schedule.forEach((ele) => {
        total += ele.percent
      })
      return total == 100
    },
    fnSubmitCreateExercise() {
      if (this.createExerciseForm.exercise_schedule.length == 0 || Tool.findIndexInArryByKeyVal(this.createExerciseForm.exercise_schedule, 'isEdit', true) > -1) {
        this.$message({
          type: 'error',
          message: '请行添加计划'
        })
        return
      }
      if (!this.verifySchedule()) {
        this.$message({
          type: 'error',
          message: '总发放股数需等于100%'
        })
        return
      }

      this.$refs.createExerciseForm.validate(valid => {
        if (valid) {
          const postForm = Object.assign({}, this.createExerciseForm)
          postForm.exercise_schedule = JSON.stringify(postForm.exercise_schedule)
          this.$http.improveExerciseSchedule(postForm).then(res => {
            this.$message({
              type: 'success',
              message: '添加成功'
            })
            this.$refs.createExerciseForm.resetFields()
            this.fnGetExerciseList()
          })
        }
      })
    },
    fnGetExerciseList: function() {
      this.bCreateExercise = false
      this.$http.getExerciseScheduleList(this.listQuery).then(res => {
        this.lists = res.data
      })
    },
    fnDeleteExercise: function(exerciseId) {
      this.$confirm('确认关闭该行权周期么，关闭后无法恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.closeExerciseSchedule({ exerciseId: exerciseId, is_delete: 1 }).then(res => {
          this.$message({
            type: 'success',
            message: '关闭成功'
          })
          this.fnGetExerciseList()
        })
      }).catch(() => {

      })
    },
    fnUpdateCreateExerciseList: function(index) {
      this.createExerciseForm.exercise_schedule[index].isEdit = false
    },
    fnDeleteCreateExerciseList: function(index) {
      this.createExerciseForm.exercise_schedule.splice(index, 1)
    },
    fnAddExercise: function() {
      this.dialogCreateExerciseKey += 1
      this.dialogAddFoodVisible = true
      this.bCreateExercise = true
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
